import React from "react";
import { GenericReportingDropdowns } from "../../containers/GenericReportingDropdowns";

const OverviewPageDropdowns = () => {
  return (
    <div>
      <GenericReportingDropdowns
        includeDateRange={true}
        includeGranularity={true}
        includeTooltipsAndTitles={false}
        containerStyle="dropdown-container"
        renderAsButton={true}
        includeCompareDateRange={true}
      />
    </div>
  );
};

export default OverviewPageDropdowns;
